// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"3b82e015","453":"691b08d8"}[chunkId] + ".chunk.js";
};